const AppConfigDefs = {
    app: {
        abreviatura: "SIN",
        nome: "Sistema de Inteligência de Negócio",
        empresa: "DHoffmann",
        footer: "DHoffmann - 2024"
    },
    login: {
        logo: {
            ligth: 'layout/dhoffmann/images/nada.png',
            dark: 'layout/dhoffmann/images/nada.png',
            style: ''
        },
        logoname: {
            ligth: 'layout/dhoffmann/images/logo-nome-light.png',
            dark: 'layout/dhoffmann/images/logo-nome-dark.png',
            style: 'width: 280px; padding-top: 12px;'
        }
    },
    topbar: {
        logo: {
            ligth: 'layout/dhoffmann/images/logo-light.png',
            dark: 'layout/dhoffmann/images/logo-dark.png',
            style: 'height:28px; padding-left: 7px;'
        },
        logoname: {
            ligth: 'layout/dhoffmann/images/nada.png',
            dark: 'layout/dhoffmann/images/nada.png',
            style: 'padding-left: 5px; padding-top: 7px; height:40px;'
        }
    },
    theme: {
        colorScheme: 'light',
        menu: 'orange',
        component: 'orange',
        menuMode: 'horizontal'
    },
    opcoes: {
        powerbi: {
            desabilitarSalvamentoAutomatico: true
        }
    },
    sifm: true
};

export default AppConfigDefs;